import { render, staticRenderFns } from "./LotHead.vue?vue&type=template&id=2354266a&scoped=true&"
import script from "./LotHead.vue?vue&type=script&lang=js&"
export * from "./LotHead.vue?vue&type=script&lang=js&"
import style0 from "./LotHead.vue?vue&type=style&index=0&id=2354266a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354266a",
  null
  
)

export default component.exports